var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NotAuthenticatedLayout',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half is-offset-one-quarter"},[_c('LoginForm',{attrs:{"validation-errors":_vm.getValidationErrors,"login-message":_vm.getLoginMessage,"loading":_vm.getAuthIsLoading},on:{"submit":_vm.onSubmit}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }